<template>
  <div class="top-layout">
    <div class="top-text-layout">
      <div v-for="(item, index) in leftList" :key="index" class="top-text-item">
        <span :class="{ activated: item.activated, text: true }" @click="onClickLabelName(item.id)">{{
          item.name
        }}</span>
        <div v-if="leftList.length - 1 != index" class="line"></div>
      </div>
    </div>
    <div class="top-logo">
      <img src="@images/bg/top_logo.png" alt="logo" @click="onClickLabelName(-1)" />
    </div>
    <div class="top-text-layout">
      <div
        v-for="(item, index) in rightList"
        :key="index"
        :class="{ 'top-text-item': true, 'has-submenu': item.children && item.children.length }"
      >
        <span :class="{ activated: item.activated, text: true }" @click="onClickLabelName(item.id)">{{
          item.name
        }}</span>
        <div v-if="item.children && item.children.length" class="submenu">
          <button
            v-for="child in item.children"
            :key="child.router"
            type="button"
            class="submenu-item"
            @click.stop="onClickSubmenu(item.id, child.router)"
          >
            {{ child.name }}
          </button>
        </div>
        <div v-if="rightList.length - 1 != index" class="line"></div>
      </div>
    </div>
    <div v-if="language == 'zh-CN'" class="language" title="切换英文" @click="changeLanguage('en-US')">
      <span>CN</span>
    </div>
    <div v-if="language == 'en-US'" class="language" title="切换中文" @click="changeLanguage('zh-CN')">
      <span>EN</span>
    </div>
  </div>
</template>

<script>
import { STATUS } from './data'
export default {
  props: {
    current: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      STATUS,
      position: 0,
      list: [
        {
          id: 0,
          router: 'ProductSystem',
          status: STATUS[0],
          name: this.$t('navigation.productSystem'),
          activated: true
        },
        {
          id: 1,
          router: 'GroupMembers',
          status: STATUS[0],
          name: this.$t('navigation.groupMembers'),
          activated: false
        },
        {
          id: 2,
          router: 'DevHistory',
          status: STATUS[0],
          name: this.$t('navigation.devHistory'),
          activated: false
        },
        {
          id: 3,
          router: 'OnlineMall',
          status: STATUS[1],
          name: this.$t('navigation.onlineMall'),
          activated: false
        },
        {
          id: 4,
          router: 'EnterpriseNews',
          status: STATUS[1],
          name: this.$t('navigation.enterpriseNews'),
          activated: false,
          children: [
            {
              router: 'EnterpriseNews',
              name: this.$t('navigation.mediaReports')
            },
            // {
            //   router: 'HistoryMedia',
            //   name: this.$t('navigation.historyMedia')
            // }
          ]
        },
        {
          id: 5,
          router: 'ContactUs',
          status: STATUS[1],
          name: this.$t('navigation.contactUs'),
          activated: false
        }
      ],
      leftList: [],
      rightList: [],
      language: localStorage.getItem('Language')
    }
  },
  mounted() {
    this.splitLabelList()
    this.setActivated(this.current)
  },
  methods: {
    // 拆分出左右标签
    splitLabelList() {
      for (let index = 0; index < this.list.length; index++) {
        const element = this.list[index]
        if (element.status === STATUS[0]) {
          this.leftList.push(element)
        } else if (element.status === STATUS[1]) {
          this.rightList.push(element)
        }
      }
    },
    // 点击标签或logo(-1)
    onClickLabelName(index) {
      this.position = index
      this.setActivated(index)
      this.$emit('onChange', this.list, this.position, this.position === -1 ? '' : this.list[this.position].router)
    },
    onClickSubmenu(parentId, router) {
      this.position = parentId
      this.setActivated(parentId)
      this.$emit('onChange', this.list, parentId, router)
    },
    setActivated(pos) {
      for (let index = 0; index < this.list.length; index++) {
        if (index === pos) {
          this.list[index].activated = true
        } else if (this.list[index].activated) {
          this.list[index].activated = false
        }
      }
    },
    changeLanguage(value) {
      this.$i18n.locale = value
      localStorage.setItem('Language', value)
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style';
</style>
